// Opt in to React Router v7 behavior early; this also silences its v6 deprecation warnings.
export const routerFuture = { v7_startTransition: true, v7_relativeSplatPath: true };
